import { useRef, useState } from "react";

export const Tilt = ({ children, className = "", max = 7 }) => {
  const ref = useRef(null);
  const [transform, setTransform] = useState("perspective(900px) rotateX(0deg) rotateY(0deg)");

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    setTransform(`perspective(900px) rotateX(${(-py * max).toFixed(2)}deg) rotateY(${(px * max).toFixed(2)}deg)`);
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={() => setTransform("perspective(900px) rotateX(0deg) rotateY(0deg)")}
      style={{
        transform,
        transformStyle: "preserve-3d",
        transition: "transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
      }}
      className={`h-full ${className}`}
    >
      {children}
    </div>
  );
};
